/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Categoryevent1Inputs */

const ja_playdata_pricing_categoryevent1 = /** @type {(inputs: Playdata_Pricing_Categoryevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツ大会レポート`)
};

const en_playdata_pricing_categoryevent1 = /** @type {(inputs: Playdata_Pricing_Categoryevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report: Esports Event`)
};

/**
* | output |
* | --- |
* | "Report: Esports Event" |
*
* @param {Playdata_Pricing_Categoryevent1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_pricing_categoryevent1 = /** @type {((inputs?: Playdata_Pricing_Categoryevent1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Categoryevent1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_categoryevent1(inputs)
	return en_playdata_pricing_categoryevent1(inputs)
});
export { playdata_pricing_categoryevent1 as "playdata_pricing_categoryEvent" }